module.exports = "/assets/1a834ad47a816cf977c35f8a83098851.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MZ.png
// module id = 1632
// module chunks = 0